import React, { useEffect, useRef } from "react";

export function SwipeHintRow({ children, count = 0, className = "", auto = false, ...rest }) {
  const ref = useRef(null);
  const holdRef = useRef(0);
  useEffect(() => {
    const el = ref.current;
    if (!auto || !el) return undefined;
    const id = setInterval(() => {
      if (Date.now() < holdRef.current || document.hidden || el.scrollWidth <= el.clientWidth) return;
      const step = (el.firstElementChild?.offsetWidth || 240) + 12;
      const end = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
      el.scrollTo({ left: end ? 0 : el.scrollLeft + step, behavior: "smooth" });
    }, 3000);
    return () => clearInterval(id);
  }, [auto, count]);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) return undefined;
    let done = false;
    const timers = [];
    const io = new IntersectionObserver(([e]) => {
      if (done || !e.isIntersecting || el.scrollLeft > 0 || el.scrollWidth <= el.clientWidth) return;
      done = true;
      io.disconnect();
      timers.push(setTimeout(() => el.scrollTo({ left: 90, behavior: "smooth" }), 250));
      timers.push(setTimeout(() => el.scrollTo({ left: 0, behavior: "smooth" }), 1050));
    }, { rootMargin: "-35% 0px -35% 0px" });
    io.observe(el);
    return () => { io.disconnect(); timers.forEach(clearTimeout); };
  }, [count]);
  const hold = () => { holdRef.current = Date.now() + 6000; };
  return <div ref={ref} className={className} onPointerDown={hold} onTouchStart={hold} {...rest}>{children}</div>;
}

export default SwipeHintRow;
